import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  paper: {
    borderRadius: 10,
  },
  paperWidthXs: {
    maxWidth: '375px',
    [theme.breakpoints.down('xs')]: {
      maxWidth: 'auto',
    },
  },
  title: {
    fontSize: '1rem',
    lineHeight: '1.5rem',
    color: '#4A4A4A',
    fontWeight: 600,
    textAlign: 'center',
  },
  rootDialog: {
    width: '375px',
    padding: '8px 0 0 0',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
  },
  contentSection: {
    padding: '24px 16px 8px 16px',
    '& ul': {
      marginTop: '12px',
      listStyle: 'none',
      margin: 0,
      paddingLeft: 24,
      fontSize: '0.8125rem',
      color: '#333',
    },
    '& li': {
      margin: '4px 0',
    },
    [theme.breakpoints.down('xs')]: {
      padding: '16px 8px 8px 8px',
    },
  },
  buttonSection: {
    padding: '12px 13px',
    borderRadius: '0 0 10px 10px',
  },
  button: {
    backgroundColor: '#AE2025',
    color: '#FFF',
    padding: '10px 32px',
    borderRadius: 10,
    textTransform: 'none',
    fontSize: '0.875rem',
    lineHeight: '1.125rem',
    fontWeight: 600,
    '&:hover': {
      backgroundColor: '#AE2025',
      color: '#FFF',
    },
  },
  boxIconPage: {
    textAlign: 'center',
  },
  iconPage: {
    width: '86px',
    height: '86px',
  },
  iconContact: {
    width: '14px',
    height: '14px',
    marginRight: '4px',
  },
}))
export default useStyles
